import React, { createContext, useContext, useState, useEffect } from 'react';
import { useToast } from '../hooks/use-toast';

const WishlistContext = createContext();

export const useWishlist = () => {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error('useWishlist must be used within a WishlistProvider');
  }
  return context;
};

export const WishlistProvider = ({ children }) => {
  const [wishlist, setWishlist] = useState([]);
  const { toast } = useToast();

  // Carregar wishlist do localStorage ao iniciar
  useEffect(() => {
    const savedWishlist = localStorage.getItem('disneylandia_wishlist');
    if (savedWishlist) {
      try {
        setWishlist(JSON.parse(savedWishlist));
      } catch (e) {
        console.error('Erro ao carregar wishlist:', e);
      }
    }
  }, []);

  // Salvar wishlist no localStorage quando mudar
  useEffect(() => {
    localStorage.setItem('disneylandia_wishlist', JSON.stringify(wishlist));
  }, [wishlist]);

  // Adicionar produto ao wishlist
  const addToWishlist = (product) => {
    if (isInWishlist(product.id)) {
      toast({
        title: "Produto já está nos favoritos",
        variant: "default"
      });
      return;
    }

    const wishlistItem = {
      id: product.id,
      name: product.name,
      brand: product.brand,
      image: product.images?.[0] || null,
      size: product.size || null,
      slug: product.slug,
      addedAt: new Date().toISOString()
    };

    setWishlist(prev => [...prev, wishlistItem]);
    toast({
      title: "❤️ Adicionado aos favoritos!",
      description: product.name
    });
  };

  // Remover produto do wishlist
  const removeFromWishlist = (productId) => {
    setWishlist(prev => prev.filter(item => item.id !== productId));
    toast({
      title: "Removido dos favoritos",
      variant: "default"
    });
  };

  // Alternar produto no wishlist
  const toggleWishlist = (product) => {
    if (isInWishlist(product.id)) {
      removeFromWishlist(product.id);
    } else {
      addToWishlist(product);
    }
  };

  // Verificar se produto está no wishlist
  const isInWishlist = (productId) => {
    return wishlist.some(item => item.id === productId);
  };

  // Limpar wishlist
  const clearWishlist = () => {
    setWishlist([]);
    toast({
      title: "Favoritos limpos",
      variant: "default"
    });
  };

  const value = {
    wishlist,
    addToWishlist,
    removeFromWishlist,
    toggleWishlist,
    isInWishlist,
    clearWishlist,
    wishlistCount: wishlist.length
  };

  return (
    <WishlistContext.Provider value={value}>
      {children}
    </WishlistContext.Provider>
  );
};
